import React from 'react';
import { Link } from 'react-router-dom';
import role from '../../util/role'
import {
    CATEGORY_LIST_PAGE_LOADED
} from '../../constants/actionTypes'
const CategoryListLink = props => {
    if (!props.currentUser
        || !role.can(props.currentUser.role, CATEGORY_LIST_PAGE_LOADED)
        || !props.userKey) {
        return (
            <span>Category List</span>
        )
    }
    return (
        <Link to={`/categories/user/${props.userKey}`}>Category List</Link>
    )
}

export default CategoryListLink;



// WEBPACK FOOTER //
// ./src/components/widgets/CategoryListLink.js